/* =========================================================
   1) Mobile product grid: force-load images the Owl carousel
   skips. Desktop is left alone.
   ========================================================= */
(function () {
  var BREAKPOINT = 992;

  function resolve(el) {
    var src = el.getAttribute('data-src') || el.getAttribute('data-srcset');
    if (!src) { return; }
    if (el.tagName === 'IMG') {
      if (el.getAttribute('data-srcset')) {
        el.setAttribute('srcset', el.getAttribute('data-srcset'));
      }
      if (el.getAttribute('data-src')) {
        el.setAttribute('src', el.getAttribute('data-src'));
      }
    } else {
      el.style.backgroundImage = 'url(' + src + ')';
    }
    el.className = el.className.replace(/\bowl-lazy\b/g, '');
    el.style.opacity = 1;
    el.removeAttribute('data-src');
  }

  function loadAll() {
    if (window.innerWidth >= BREAKPOINT) { return; }
    var blocks = document.querySelectorAll('.ishiproduct-block');
    for (var b = 0; b < blocks.length; b++) {
      var nodes = blocks[b].querySelectorAll('[data-src], .owl-lazy');
      for (var i = 0; i < nodes.length; i++) {
        resolve(nodes[i]);
      }
    }
  }

  function schedule() {
    loadAll();
    setTimeout(loadAll, 400);
    setTimeout(loadAll, 1200);
    setTimeout(loadAll, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(loadAll, 200);
  });
})();


/* =========================================================
   Shared: Custom EDP identity
   If the product's variants are ever deleted and recreated,
   update CUSTOM_EDP_VARIANTS with the new IDs.
   ========================================================= */
var CUSTOM_EDP_HANDLE = 'la-scentoure-custom-edp';
var CUSTOM_EDP_URL = '/products/' + CUSTOM_EDP_HANDLE;
var CUSTOM_EDP_VARIANTS = [
  '56367392489777',   /* 10ml  */
  '56367392522545',   /* 30ml  */
  '56367392555313'    /* 120ml */
];

function isCustomEdpVariant(id) {
  if (id === null || id === undefined) { return false; }
  return CUSTOM_EDP_VARIANTS.indexOf(String(id).replace(/^\s+|\s+$/g, '')) !== -1;
}

function sendToCustomEdpPage() {
  window.location.href = CUSTOM_EDP_URL + '?need=fragrance';
}


/* =========================================================
   2) Custom EDP product page: make sure the Fragrance Name
   reaches the order. The theme's Add to Cart sends only the
   variant and quantity, dropping line-item properties, so
   this posts to /cart/add.js itself with the property
   included. The product template's inline script blocks an
   empty submission first, so this only acts when the field
   has a value.
   ========================================================= */
(function () {
  var busy = false;

  function findVariantId(form) {
    var sel = form.querySelector('select[name="id"]');
    if (sel && sel.value) { return sel.value; }
    var hidden = form.querySelector('input[name="id"]');
    if (hidden && hidden.value) { return hidden.value; }
    return null;
  }

  function findQuantity(form) {
    var q = form.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return (isNaN(n) || n < 1) ? 1 : n;
  }

  function showError(input, msg) {
    var err = document.querySelector('[data-fragrance-note-error]');
    if (err) {
      err.textContent = msg;
      err.className = 'fragrance-note-error is-visible';
    } else {
      window.alert(msg);
    }
    if (input) { input.style.borderColor = '#d20000'; }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) { return; }
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) { return; }

    var input = document.querySelector('[data-fragrance-note]');
    if (!input) { return; }

    var fragrance = input.value.replace(/^\s+|\s+$/g, '');
    if (fragrance === '') { return; }

    var form = btn.closest('form');
    if (!form) { return; }

    e.preventDefault();
    e.stopImmediatePropagation();

    if (busy) { return; }

    var variantId = findVariantId(form);
    if (!variantId) {
      showError(input, 'Please choose a size before adding to cart.');
      return;
    }

    busy = true;
    btn.setAttribute('disabled', 'disabled');
    var label = btn.querySelector('[data-add-to-cart-text]');
    var originalLabel = label ? label.innerHTML : null;
    if (label) { label.innerHTML = 'Adding...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId, 10),
          quantity: findQuantity(form),
          properties: { 'Fragrance Name': fragrance }
        }]
      })
    })
    .then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          throw new Error(data && (data.description || data.message) || 'Could not add to cart.');
        }
        return data;
      });
    })
    .then(function () {
      window.location.href = '/cart';
    })
    .catch(function (err) {
      busy = false;
      btn.removeAttribute('disabled');
      if (label && originalLabel !== null) { label.innerHTML = originalLabel; }
      showError(input, (err && err.message) ? err.message : 'Could not add to cart. Please try again.');
    });
  }, true);
})();


/* =========================================================
   3) Guard the theme's shared add-to-cart function.

   quickview.js defines a global productAddToCart(varID, qty)
   that the theme calls for quick view AND the product page.
   It posts only id and quantity, so Custom EDP added through
   it arrives with no fragrance name.

   Wrapping that function is the most reliable guard: it does
   not depend on which button was clicked or how the click
   was handled. If the variant is Custom EDP, the customer is
   sent to the product page instead. Any other variant goes
   through the original function unchanged.

   Scripts load with defer in document order, and quickview.js
   comes before this file, so the function already exists by
   the time this runs. The retry loop covers the rare case it
   does not.
   ========================================================= */
(function () {
  var tries = 0;

  function install() {
    var original = window.productAddToCart;
    if (typeof original !== 'function') {
      if (tries++ < 40) { setTimeout(install, 250); }
      return;
    }
    if (original.__customEdpGuarded) { return; }

    var guarded = function (varID, qty) {
      if (isCustomEdpVariant(varID)) {
        try { if (window.jQuery) { window.jQuery('#quickviewModal').modal('hide'); } } catch (x) {}
        try {
          if (window.jQuery) {
            window.jQuery('.qv-addToCart span.adding').hide();
            window.jQuery('.qv-addToCart span.instock').show();
          }
        } catch (y) {}
        sendToCustomEdpPage();
        return;
      }
      return original.apply(this, arguments);
    };
    guarded.__customEdpGuarded = true;
    window.productAddToCart = guarded;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }
})();


/* =========================================================
   4) Click-level guard, as a second layer.

   Catches Custom EDP add buttons outside its own product
   page (quick view, cards) before the theme handler runs.
   Block 3 is the primary guard; this is belt and braces.
   ========================================================= */
(function () {
  function variantFromScope(btn) {
    var form = btn.closest('form');
    var scope = form || btn.closest('#qv-quantity, #quickviewModal, .grid-view-item, .list-view-item');
    if (!scope) { return null; }
    var el = scope.querySelector(
      'select[name="id"], input[name="id"], ' +
      'select[name="prduct-variant"], input[name="prduct-variant"]'
    );
    return el && el.value ? String(el.value) : null;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) { return; }
    var btn = e.target.closest('.qv-addToCart, .nm-addToCart, .addToCart, [data-add-to-cart]');
    if (!btn) { return; }

    var form = btn.closest('form');
    if (form && form.querySelector('[data-fragrance-note]')) { return; }

    if (!isCustomEdpVariant(variantFromScope(btn))) { return; }

    e.preventDefault();
    e.stopImmediatePropagation();
    try { if (window.jQuery) { window.jQuery('#quickviewModal').modal('hide'); } } catch (x) {}
    sendToCustomEdpPage();
  }, true);
})();


/* =========================================================
   5) On arrival from a redirect, point the customer at the
   Fragrance Name field.
   ========================================================= */
(function () {
  function highlightField() {
    if (window.location.search.indexOf('need=fragrance') === -1) { return; }
    var input = document.querySelector('[data-fragrance-note]');
    if (!input) { return; }
    var err = document.querySelector('[data-fragrance-note-error]');
    if (err) {
      err.textContent = 'This is a made-to-order fragrance. Please tell us which scent you want, then add to cart.';
      err.className = 'fragrance-note-error is-visible';
    }
    input.style.borderColor = '#d20000';
    try {
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (x) {
      input.scrollIntoView();
    }
    setTimeout(function () { input.focus(); }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', highlightField);
  } else {
    highlightField();
  }
})();
